'use client'
import { defineStyleConfig, Text as ChakraText } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TextProps } from './Text.types'

export const TextStyle = defineStyleConfig({
  baseStyle: {
    color: 'gray.800',
  },
})

export default forwardRef(function Text(
  props: TextProps,
  ref: LegacyRef<HTMLParagraphElement>
) {
  return <ChakraText {...props} ref={ref} translate="no" />
})
